import CommentInputComponent from './CommentInput';

export { default } from './CommentBar';
export const CommentInput = CommentInputComponent;
